import React from 'react';
import { AppProvider } from './src/context/AppContext';
import { SERVICES_ROUTE } from './src/utils/routes';
import { handleScrollToTop } from './src/utils/functions';
import './src/styles/app.scss';

export const wrapRootElement = ({ element }) => (
  <AppProvider>
    {element}
  </AppProvider>
);

export const onRouteUpdate = ({ location }) => {
  if (
    location.pathname !== `${SERVICES_ROUTE}/`
  ) {
    setTimeout(() => {
      handleScrollToTop()
    }, 0)
  }
}